export class Config {
    public static EMAILJS_SERVICE_KEY = process.env.REACT_APP_EMAILJS_SERVICE_KEY; 
    public static EMAILJS_TEMPLATE_KEY = process.env.REACT_APP_EMAILJS_TEMPLATE_KEY; 
    public static EMAILJS_USER_KEY = process.env.REACT_APP_EMAILJS_USER_KEY; 
}